import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../services/category/category.service';
import { ActivatedRoute, NavigationExtras, ParamMap, Router } from '@angular/router';
import { ProductService } from "../services/product/product.service";
import { environment } from "../../environments/environment";
import { HttpParams } from '@angular/common/http';


@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {


  categories=[];
  fournisseurs=[];
  productByCategory;
  pageSize = 12;
  page;
  total;
  contentLoaded = false;
  listF1=[];
  listF2=[];
  listF3=[];
  listF3Filtre = [];
  defaultParent
  baseUrl = environment.baseUrl
  fileTitiles = {f1:"",f2:"",f3:""}
  checkedFournisseurs:any=[];
  startIndex = 1;
  totalPages = 0;
  itemsPerPage = 12;
  pageNumbers:any;
  level = 'TSICOD2'
  nv
  subCategories = []
  constructor(private categoryService:CategoryService,private route: ActivatedRoute,private productService:ProductService,private router: Router) { }

  nextPage() {
    if (this.startIndex < this.totalPages) {
      this.startIndex++;
      var param: any = {
        page: this.startIndex
      };
      if (this.nv != undefined) {
        param.nv = 1;
      }
      if (this.checkedFournisseurs.length > 0) {
        param.fournisseurs = this.checkedFournisseurs.join(',');
      }
      const queryParams: NavigationExtras = {
        queryParams: param
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.loadData();
    }
  }

  previousPage() {
    if (this.startIndex > 1) {
      this.startIndex--;
      var param: any = {
        page: this.startIndex
      };
      if (this.nv != undefined) {
        param.nv = 1;
      }
      if (this.checkedFournisseurs.length > 0) {
        param.fournisseurs = this.checkedFournisseurs.join(',');
      }
      const queryParams: NavigationExtras = {
        queryParams: param
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.loadData();
    }
  }

  goToPage(pageNumber: number) {
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.startIndex = pageNumber;
      var param: any = {
        page: this.startIndex
      };
      if (this.nv != undefined) {
        param.nv = 1;
      }
      if (this.checkedFournisseurs.length > 0) {
        param.fournisseurs = this.checkedFournisseurs.join(',');
      }
      const queryParams: NavigationExtras = {
        queryParams: param
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.loadData();
    }
  }

  updatePageNumbers() {
    if (this.totalPages > 10) {
      if (
        Number(this.startIndex) <= this.totalPages - 5 &&  Number(this.startIndex) > this.totalPages - 5 || 
        Number(this.startIndex) <= this.totalPages - 4 &&  Number(this.startIndex) > this.totalPages - 5 ||
        Number(this.startIndex) <= this.totalPages - 3 &&  Number(this.startIndex) > this.totalPages - 5 ||
        Number(this.startIndex) <= this.totalPages - 2 &&  Number(this.startIndex) > this.totalPages - 5 ||
        Number(this.startIndex) <= this.totalPages - 1 &&  Number(this.startIndex) > this.totalPages - 5 ||
        Number(this.startIndex) <= this.totalPages &&  Number(this.startIndex) > this.totalPages - 5
        ) {
        this.pageNumbers = [
          1, 2 , '...', this.totalPages - 4,  this.totalPages - 3,  this.totalPages - 2,  this.totalPages - 1,  this.totalPages
        ];
      } else {
        if (Number(this.startIndex) > 2) {
          this.pageNumbers = [
            1, 2 , '...', this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
          ];
        } else {
          this.pageNumbers = [
            this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
          ];
        }
      }
    } else {
      this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1);
    }
  }

  loadData() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      let idParam = params.get('id')
      console.log(params);
      
      // Get query params synchronously using snapshot
      const queryParams = this.route.snapshot.queryParams;
      this.nv = queryParams['nv'];
      
      // Load fournisseurs from URL query params
      if (queryParams['fournisseurs']) {
        this.checkedFournisseurs = queryParams['fournisseurs'].split(',').filter(f => f);
      } else {
        this.checkedFournisseurs = [];
      }
      
      console.log('nv',this.nv );
      
      var nv = 'TSICOD2'
      if (this.nv != undefined) {
        nv = 'TSICOD1'
      }
      
      // Apply fournisseurs filter if any are selected
      if (this.checkedFournisseurs.length > 0) {
        this.productService.productByCategory(idParam, this.startIndex, this.itemsPerPage, nv, this.checkedFournisseurs).subscribe(res => {
          this.productByCategory = res['produits'];
          this.defaultParent = this.productByCategory[0]['TSICOD0']
          if(this.nv == undefined){
            idParam = this.productByCategory[0]['TSICOD1']
          }
          this.totalPages = Math.ceil(Number(res['total']) / this.itemsPerPage);
          this.updatePageNumbers();

          this.fournisseurs = [...new Set(res['fournisseurs'])];

          this.total = this.productByCategory.length;
          
          this.contentLoaded = true;
          this.categoryService.allCategoriesByNv(this.defaultParent,idParam).subscribe(res =>{
            console.log(res);
            this.fileTitiles.f1 = res['titre']
            this.fileTitiles.f3 = res['f2']
            this.subCategories = []
            for(var k in res['categories']){
              this.subCategories.push({"id":k,"titre":res['categories'][k]}) 
            }
            
          })
        });
      } else {
        this.productService.productByCategory(idParam, this.startIndex, this.itemsPerPage, nv).subscribe(res => {
          this.productByCategory = res['produits'];
          this.defaultParent = this.productByCategory[0]['TSICOD0']
          if(this.nv == undefined){
            idParam = this.productByCategory[0]['TSICOD1']
          }
          this.totalPages = Math.ceil(Number(res['total']) / this.itemsPerPage);
          this.updatePageNumbers();

          this.fournisseurs = [...new Set(res['fournisseurs'])];

          this.total = this.productByCategory.length;
          
          this.contentLoaded = true;
          this.categoryService.allCategoriesByNv(this.defaultParent,idParam).subscribe(res =>{
            console.log(res);
            this.fileTitiles.f1 = res['titre']
            this.fileTitiles.f3 = res['f2']
            this.subCategories = []
            for(var k in res['categories']){
              this.subCategories.push({"id":k,"titre":res['categories'][k]}) 
            }
            
          })
        });
      }
       
      //  this.categoryService.allCategories().subscribe(res =>{
      //    this.listF1=[];
      //    this.listF2=[];
      //    this.listF3=[];
      //    this.categories = res['categories'];
      //    this.formatDataCategories(this.categories);
        
        


      //   if(this.level == 'TSICOD1'){
      //     var categorySelected = this.listF2.filter(function(f2) {
      //       if (f2.id === idParam) {
      //         return f2;
      //       }
      //     });
      //   }else{
      //     var categorySelected = this.listF3.filter(function(f3) {
      //       if (f3.id === idParam) {
      //         return f3;
      //       }
      //     });
      //   }
         
        
      //    this.fileTitiles.f3 = categorySelected[0].titre

      //    this.filtreF3ByF2(categorySelected[0].parent);
      //    if(this.level == 'TSICOD1'){
      //     var lstF2Filtre = this.listF1.filter((f1)=>{
      //       if(f1.id == categorySelected[0].parent){
      //         return f1;
      //       }
      //     })
      //    }else{
      //     var lstF2Filtre = this.listF2.filter((f2)=>{
      //       if(f2.id == categorySelected[0].parent){
      //         return f2;
      //       }
      //     })
      //    }
   
      //    this.fileTitiles.f2 = lstF2Filtre[0].titre

      //    var lstF1Filtre = this.listF1.filter((f1)=>{
      //      if(f1.id == lstF2Filtre[0].id){
      //       return f1;
      //      }
      //    })
      //    //this.fileTitiles.f1 = lstF1Filtre[0].titre

      //    this.listF2 = lstF2Filtre;
      //    if(lstF2Filtre[0].parent){
      //     this.defaultParent = lstF2Filtre[0].parent;
      //    }else{
      //     this.defaultParent = lstF2Filtre[0].id;
      //    }
      //    this.subCategories = []
      //    this.categoryService.allSubCategories().subscribe(res =>{
      //     var subCategoriesTemp = res['categories'][this.defaultParent]
          
      //     for(var k in subCategoriesTemp){
      //       this.subCategories.push({id:k,titre:subCategoriesTemp[k]})
      //     }
      //     this.listF1.forEach(item=>{
      //       if(item.id==this.defaultParent){
      //         this.fileTitiles.f1 = item.titre
      //       }
      //     })
      //     console.log("sub",this.subCategories);
          
      //   })

      //  })
      

    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['page']) {
        this.startIndex = params['page'];
      }
      if (params['nv']) {
        console.log('params', params);
        this.level = 'TSICOD1';
      }else {
        this.level = 'TSICOD2';
      }
      // Load fournisseurs from URL query params on init
      if (params['fournisseurs']) {
        this.checkedFournisseurs = params['fournisseurs'].split(',').filter(f => f);
      } else {
        this.checkedFournisseurs = [];
      }
    })
    this.loadData();
  }


  changeMax(nbrProducts)
  {
    // this.pageSize = nbrProducts;
    this.itemsPerPage = nbrProducts;
    this.startIndex = 1;
    
    // Update URL query params to reset page to 1 and preserve fournisseurs
    var param: any = {
      page: 1
    };
    if (this.nv != undefined) {
      param.nv = 1;
    }
    if (this.checkedFournisseurs.length > 0) {
      param.fournisseurs = this.checkedFournisseurs.join(',');
    }
    const queryParams: NavigationExtras = {
      queryParams: param
    };
    this.router.navigate([], queryParams);
    
    this.loadData();
    
    // this.productByCategory.length = nbrProducts
  }

  filtreByFournisseur(event:any)
  {
    // Reset pagination to page 1 when filter changes
    this.startIndex = 1;
    
    if (this.checkedFournisseurs.filter(f => f == event.target.value).length == 0) {
      this.checkedFournisseurs.push(event.target.value);
    }else{
      const index = this.checkedFournisseurs.indexOf(event.target.value);
      if (index > -1) {
        this.checkedFournisseurs.splice(index, 1);
      }
    }
    var nv = 'TSICOD2'
      if (this.nv != undefined) {
        nv = 'TSICOD1'
     }
    let idParam = this.route.snapshot.paramMap.get('id');
    
    // Update URL query params to reset page to 1 and save fournisseurs
    var param: any = {
      page: 1
    };
    if (this.nv != undefined) {
      param.nv = 1;
    }
    if (this.checkedFournisseurs.length > 0) {
      param.fournisseurs = this.checkedFournisseurs.join(',');
    }
    const queryParams: NavigationExtras = {
      queryParams: param
    };
    this.router.navigate([], queryParams);
    
    if (this.checkedFournisseurs.length == 0) {
      this.productService.productByCategory(idParam,this.startIndex, this.itemsPerPage,nv).subscribe(res => {
        this.productByCategory = res['produits'];
        // this.fournisseurs = [...new Set(res['fournisseurs'])];

        this.total = this.productByCategory.length;
        this.totalPages = Math.ceil(Number(res['total']) / this.itemsPerPage);
        this.updatePageNumbers();
        this.contentLoaded = true;
      });
    }else {
      var nv = 'TSICOD2'
      if (this.nv != undefined) {
        nv = 'TSICOD1'
     }
      this.productService.productByCategory(idParam,this.startIndex,this.itemsPerPage,nv,this.checkedFournisseurs).subscribe(res => {
         this.productByCategory = res['produits'];
         // this.fournisseurs = [...new Set(res['fournisseurs'])];

         this.total = this.productByCategory.length;
         this.totalPages = Math.ceil(Number(res['total']) / this.itemsPerPage);
         this.updatePageNumbers();
         this.contentLoaded = true;
       });
    }

  }

  filtreF3ByF2(f2Id)
  {
    this.listF3Filtre = [];

    this.listF3Filtre = this.listF3.filter(function(f3) {
      if (f3.parent === f2Id) {
        return f3;
      }

    });

  }

  formatDataCategories(categories)
  {
    
    var objectTemp = {id:'',titre:'',categories:{},parent:null};
    for (var i in categories)
    {
      
      objectTemp = categories[i];
      objectTemp.id = i.toString();
      this.listF1.push(objectTemp);
    }
    

    var f2Temp;
    this.listF1.forEach(f1 => {
      f2Temp = f1.categorie;
      
      for( var i in f2Temp ) 
      {

        objectTemp = f2Temp[i];
        objectTemp.id = i;
        objectTemp.parent =  f1.id;
        this.listF2.push(objectTemp);
      }
    });

    var f3Temp;
    this.listF2.forEach(f2 => {

      if (f2.categories != undefined && f2.categories.length!=0  ) {

        f3Temp =f2.categories;
        
        for (var i in f3Temp)
        {
          objectTemp.titre = f3Temp[i];
          objectTemp.id = i;
          objectTemp.parent =  f2.id;
          this.listF3.push(objectTemp);
          objectTemp = {id:'',titre:'',categories:{},parent:null};
        }
      }
    });

  }



}
